module.exports = __webpack_public_path__ + "img/chart.7054150a.svg";